ixModuleRouting("impactx.changeauthorization", {
    "/changeauthorization": {
        template: "<ixa-change-authorization></ixa-change-authorization>",
        templateUrl:
            "modules/changeauthorization/templates/changeauthorization.html",
        controller: "ChangeAuthorizationCtrl",
        controllerAs: "changeAuthorizationCtrl",
        process: "ChangeAuth",
    },
});
